export default __webpack_public_path__ + "static/media/avatar_nikki_dog3.3f07f2b1.mp3";